const awsmobile = {
    Auth: {
        Cognito: {
            userPoolId: "us-east-1_4kJ9lGMpe",
            userPoolClientId: "2egp0stj3tdsjunvdab5jpa9t6",
        }
    }
}

export default awsmobile;